import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "What is included in website development and marketing?",
    a: "It includes website design, development, SEO optimization, content strategy, technical improvements, and marketing strategies focused on traffic and conversions.",
  },
  {
    q: "Are your SEO services affordable for small businesses?",
    a: "Yes. Our affordable SEO services in USA are designed specifically for startups and small businesses that want sustainable growth without large agency costs.",
  },
  {
    q: "Do you help businesses rank on AI platforms?",
    a: "Yes. We optimize websites for modern AI-driven search experiences, including semantic search visibility and AI answer platforms.",
  },
  {
    q: "Why combine SEO with website development?",
    a: "Combining both ensures your website is optimized from the beginning, improving performance, rankings, and user experience while avoiding costly fixes later.",
  },
  {
    q: "How long does it take to see SEO results?",
    a: "SEO usually takes around 3–6 months depending on competition, industry, and website condition. Technical improvements and user experience enhancements can show faster results.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-24 lg:py-32 bg-lilac">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-1 text-xs font-medium text-brand-deep border border-[hsl(var(--brand-violet)/.15)]">
            FAQ
          </div>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-[hsl(var(--brand-navy))]">
            Frequently asked <span className="text-gradient-brand">questions</span>
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border transition-all duration-300 ${
                  isOpen ? "bg-white border-brand/30 card-shadow" : "bg-white/60 border-black/5"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between text-left p-5 sm:p-6 gap-4"
                >
                  <span className="font-semibold text-[hsl(var(--brand-navy))] text-base sm:text-lg">{f.q}</span>
                  <span
                    className={`h-8 w-8 shrink-0 rounded-full grid place-items-center border transition-all ${
                      isOpen ? "brand-gradient border-transparent text-white" : "border-black/10 text-brand-deep"
                    }`}
                  >
                    {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-500 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 sm:px-6 pb-6 text-slate-600 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
